import React, { ReactNode } from 'react';
import './DatePickerCalendar.scss';
import DatePicker, { registerLocale } from 'react-datepicker';
import ru from 'date-fns/locale/ru';
import { classNameBuilder } from '../../utils/className';
import 'react-datepicker/dist/react-datepicker.css';

interface IProps {
    onChange: (e: any) => void;
    value: any;
    customInput: ReactNode | any;
    theme?: 'dark' | 'light';
    minDate?: Date;
    maxDate?: Date;
    disabled?: boolean;
}

const DatePickerCalendar: React.FC<IProps> = ({
    onChange,
    value,
    customInput,
    theme = 'light',
    minDate,
    maxDate,
    disabled = false,
}) => {
    const cn = classNameBuilder('date-picker-calendar');

    registerLocale('ru', ru);

    const convertDate = (dateString: any | Date) => {
        if (dateString !== undefined) {
            if (typeof dateString === 'string') {
                const date = dateString?.split('-');
                return new Date(Number(date[0]), Number(date[1]) - 1, Number(date[2]));
            } else {
                return dateString;
            }
        }
    };

    const handleChange = (date: Date) => {
        const convertedDate = `${date.getFullYear()}-${(date.getMonth() + 1)
            .toString()
            .padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;

        onChange(convertedDate);
    };

    return (
        <DatePicker
            className={cn('show--input')}
            wrapperClassName={cn('picker')}
            popperClassName={cn('popper', { theme: theme })}
            selected={convertDate(value)}
            onChange={handleChange}
            showPopperArrow={false}
            locale={'ru'}
            popperPlacement={'bottom-end'}
            dateFormat={'dd-MM-yyyy'}
            customInput={customInput}
            showMonthDropdown
            showYearDropdown
            showMonthYearDropdown={false}
            dateFormatCalendar="MMMM"
            minDate={minDate && new Date(minDate)}
            maxDate={maxDate && new Date(maxDate)}
            yearDropdownItemNumber={70}
            scrollableYearDropdown
            disabled={disabled}
        />
    );
};

export default DatePickerCalendar;
